<script>
  // Replaces user/modules/ui_elements/loader + loading. `fullScreen` centres it in the viewport.
  //
  // `error` restores React loader.jsx's second state: the component that shows the spinner while a
  // request is in flight shows the failure when it comes back, so no screen can leave a spinner
  // turning over a request that already failed. React read `error.response.status` /
  // `error.response.data.message` off the axios error; lib/api/client.js flattens both onto the
  // error itself (`status`, `message`), and a transport failure (offline, DNS, CORS) has no status
  // at all — which is the generic-message case, exactly as in React.
  import { t } from "../i18n/i18n.svelte.js";

  let { fullScreen = false, label = "Loading…", error = null } = $props();

  const status = $derived(error?.status ?? null);
</script>

{#if error}
  <div class="loader-error" class:fullscreen={fullScreen} role="alert">
    {#if status}
      <p class="status">{status}</p>
      <p class="message">{error.message}</p>
    {:else}
      <p class="message">{t("error_occured")}</p>
    {/if}
    <p class="hint">{t("try_to_refresh")}</p>
    <button class="btn secondary" onclick={() => window.location.reload()}>{t("refresh")}</button>
  </div>
{:else}
  <div class="loader" class:fullscreen={fullScreen}>
    <div class="spinner"></div>
    {#if label}<span>{label}</span>{/if}
  </div>
{/if}

<style>
  .loader { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 40px; color: var(--muted); }
  .loader.fullscreen { min-height: 60vh; justify-content: center; }
  .spinner {
    width: 24px; height: 24px;
    border: 3px solid var(--border); border-top-color: var(--accent);
    border-radius: 50%; animation: spin 0.8s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  .loader-error {
    display: flex; flex-direction: column; align-items: center; gap: 6px;
    padding: 32px 20px; margin: 12px;
    border: 1px solid var(--border); border-radius: 10px;
    background: var(--card-bg); color: var(--text); text-align: center;
  }
  .loader-error.fullscreen { min-height: 60vh; justify-content: center; }
  .loader-error .status { margin: 0; font-size: 26px; font-weight: 700; }
  .loader-error .message { margin: 0; font-size: 15px; font-weight: 600; word-break: break-word; }
  .loader-error .hint { margin: 0; font-size: 13px; color: var(--muted); }
  .loader-error button { margin-top: 10px; }
</style>
